import React from 'react'
import styled from 'styled-components'

import { theme } from '../../constants/theme'

export const BlockStyled = styled.div`
  background: ${theme.colors.white};
  width: 100%;
  border-radius: 5px;
  padding: 10px;
  ${({ border }) => (border ? 'border: 1px solid rgba(0, 0, 0, 0.08);' : '')}
  ${({ shadow }) => (shadow ? 'filter: drop-shadow(0px 20px 100px rgba(0, 0, 0, 0.1));' : '')}
  margin-bottom: 2px;
`


export const Block = ({
  border, shadow, ...rest
}) => <BlockStyled {...rest} border={border} shadow={shadow} />
